import React, { useState } from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import Modal from "../Modal/Modal";
import Skills from "../Skills/Skills";
import Projects from "../Projects/Projects";

const Home = () => {
  const [modalActive, setModalActive] = useState(false);

  const showModal = () => {
    setModalActive(!modalActive);
  };

  return (
    <>
      <div className="main">
        <div>
          <h1 className="main-header">
            Hey my name is <span>Sherefat Onibile</span>{" "}
          </h1>
          <p className="main-status">
            UI/UX Designer, Frontend Developer, Project Management Coordinator
          </p>
          <div className="main-btn">
            <Link onClick={showModal} to="/Portfolio/">
              View Projects
            </Link>
          </div>
          {modalActive && <Modal showModal={showModal} />}
        </div>
      </div>
      <Skills />
      <Projects />
    </>
  );
};

export default Home;
